import { cn } from "@/lib/utils";

type BadgeTone = "default" | "accent" | "energy" | "amber" | "online";

interface HUDStatusBadgeProps {
  status: string;
  label?: string;
  tone?: BadgeTone;
  className?: string;
}

export function HUDStatusBadge({ status, label = "STATUS", tone = "default", className }: HUDStatusBadgeProps) {
  return (
    <span
      data-testid="hud-status-badge"
      className={cn(
        "inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em]",
        tone === "accent" && "border-safety/50 text-safety",
        tone === "energy" && "border-energy/50 text-energy",
        tone === "amber" && "border-amber/50 text-amber",
        tone === "online" && "border-energy/30 bg-energy/10 text-energy shadow-[0_0_20px_-6px_rgba(16,185,129,0.6)]",
        tone === "default" && "border-cad/40 text-white/70",
        className,
      )}
    >
      <span
        aria-hidden
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          tone === "accent" && "bg-safety",
          tone === "energy" && "bg-energy",
          tone === "amber" && "bg-amber",
          tone === "online" && "bg-energy shadow-[0_0_8px_1px_rgba(16,185,129,0.7)]",
          tone === "default" && "bg-cad",
        )}
      />
      [{label}: {status}]
    </span>
  );
}
